// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"565":"sl/css/owl.carousel.min","571":"sl/css/splus","581":"sl/css/loader","631":"sl/css/lander","636":"sl/css/app","959":"sl/css/merchants"}[chunkId] + ".css";
};